/**
 * Chemins de l'ecran « Contenus ».
 *
 * Module **pur**, comme `admin/data/routes.ts` : le menu (`ui/navigation.ts`) et
 * `App.tsx` l'importent tous deux, et un chemin ecrit en clair aux deux endroits
 * se maintiendrait deux fois.
 *
 * Une seule route `/content/*` monte l'ecran, et le document ouvert vit dans
 * l'URL :
 *
 *   /content        le premier document (CGU)
 *   /content/cgu    les CGU
 *   /content/cgv    les CGV
 */

export const CONTENT_PATH = '/content';

export const CONTENT_ROUTE = '/content/*';
